export default {
  getCardList: state => state.cardList,
  getAutoshipSubscriptionList: state => state.subscriptionList,
  getAutoshipSubscriptionDetails: state => state.subscriptionDetail,
}
